const imagesSizes = {
  THUMB: 0,
  SMALL: 1,
  NORMAL: 2,
  FULL: 3,
  SHAREABLE: 4
};

export default imagesSizes;
